import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import SwitcherThree from "../../../components/Dashboard/Switchers/SwitcherThree.tsx";
import { Link } from "react-router-dom";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { storage } from "../../../firebase";
// import firebase from "firebase/app";
import "firebase/firestore";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";

import { Flip, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Loader from "../../Loader/Loader";
// import ButtonLoading from "../../Loader/ButtonLoading";
// import IconParkCorrect from "../../IconParkCorrect";
// import GridiconsCrossCircle from "../../GridiconsCrossCircle";
import { useForm } from "react-hook-form";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: "100%",
  height: "100%",
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
};
const ImageUploader = () => {
  const [files, setFiles] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  const clearFiles = () => {
    setFiles([]);
    if (disabled) {
      setDisabled(false);
    }
  };
  // const handleUpload = async (imageCopyright) => {
  //   setDisabled(true);

  //   if (files[0]) {
  //     // await setImage(files[0]);
  //     console.log(files[0]);
  //   }
  //   const storageRef = await ref(
  //     storage,
  //     `images/promotionalImages/${await files[0].name}`
  //   );
  //   const uploadTask = uploadBytesResumable(storageRef, files[0]);

  //   uploadTask.on(
  //     "state_changed",
  //     function (snapshot) {
  //       const newPercent =
  //         (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  //       // setPercent(newPercent);
  //       // console.log(percent + "% done");
  //     },

  //     (error) => {
  //       console.log(error);
  // toast.error("Something went wrong!", {
  //   position: "top-right",
  //   autoClose: 5000,
  //   hideProgressBar: false,
  //   closeOnClick: true,
  //   pauseOnHover: true,
  //   draggable: true,
  //   progress: undefined,
  //   theme: "colored",
  //   transition: Flip,
  // });
  //       setDisabled(false);
  //     },
  //     async () => {
  //       // Complete function
  //       await getDownloadURL(uploadTask.snapshot.ref).then(
  //         async (downloadURL) => {
  //           // await setUrl(downloadURL);
  //           const dataImage = {
  //             imageCopyright,
  //             imageURL: downloadURL,
  //           };

  //           console.log(downloadURL, "url image");
  //           await axiosPrivate
  //             .post("/article/uploadImage", dataImage, {
  //               withCredentials: true,
  //             })
  //             .then((res) => {
  //               console.log(res?.data);
  //               toast.success("Your Image has been uploaded successfully! 👌", {
  //                 position: "top-right",
  //                 autoClose: 5000,
  //                 hideProgressBar: false,
  //                 closeOnClick: true,
  //                 pauseOnHover: true,
  //                 draggable: true,
  //                 progress: undefined,
  //                 theme: "colored",
  //                 transition: Flip,
  //               });
  //               setFiles([]);

  //               setDisabled(false);
  //             })
  //             .catch((err) => {
  //               console.log(err);
  //               toast.error("Something went wrong!", {
  //                 position: "top-right",
  //                 autoClose: 5000,
  //                 hideProgressBar: false,
  //                 closeOnClick: true,
  //                 pauseOnHover: true,
  //                 draggable: true,
  //                 progress: undefined,
  //                 theme: "colored",
  //                 transition: Flip,
  //               });
  //               setDisabled(false);
  //             });
  //         }
  //       );
  //     }
  //   );
  // };
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [],
    },
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      setFiles(
        // acceptedFiles[0]
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
      // console.log(files);
    },
  });
  const thumbs = files.map((file) => (
    // console.log(files),
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img
          src={file.preview}
          style={img}
          className="w-max-full h-60"
          // Revoke data uri after image is loaded
          onLoad={() => {
            URL.revokeObjectURL(file.preview);
          }}
        />
      </div>
    </div>
  ));
  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  return (
    <>
      <ToastContainer />
      <div className="p-3">
        {" "}
        <div className="mt-3">
          <form
            className="mx-3"
            onSubmit={handleSubmit((data) => {
              console.log(data);
              // handleUpload(data.imageCopyright);
            })}
          >
            <div className="">
              <label className="my-3 block text-white dark:text-white">
                imageCopyright*
              </label>
              <input
                {...register("imageCopyright", {
                  required: "This field is required.",
                })}
                type="text"
                placeholder="image copyright text"
                className=" w-full  rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-white outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
              />
            </div>
            <section className="container">
              <aside style={thumbsContainer} className="">
                {thumbs}
              </aside>
            </section>

            {files.length == 0 ? (
              <>
                <div
                  class="w-60 relative border-2 border-gray-300 border-dashed rounded-lg p-2"
                  id="dropzone"
                >
                  <div {...getRootProps({ className: "dropzone" })}>
                    <div class="text-center">
                      <img
                        class="mx-auto text-white h-12 w-12"
                        src="https://www.svgrepo.com/show/357902/image-upload.svg"
                        alt=""
                      />

                      <h3 class="mt-2 text-sm font-medium text-gray-900">
                        <label
                          for="file-upload"
                          class="relative cursor-pointer"
                        >
                          <input {...getInputProps()} />
                          <p className="text-white">
                            Drag 'n' drop some files here, or click to select
                            files
                          </p>
                          {/* <span>Drag and drop</span>
            <span class="text-indigo-600"> or browse</span>
            <span>to upload</span> */}
                        </label>
                      </h3>
                      <p class="mt-1 text-xs text-white">
                        PNG, JPG, GIF up to 10MB
                      </p>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {/* {url && <img src={url} alt="Uploaded" />} */}
            <div className="flex mt-3 ">
              <button
                disabled={disabled}
                type="submit"
                className={`inline-flex ${
                  disabled ? "opacity-50" : ""
                }   items-center justify-center rounded-md border border-primary py-1 px-3 text-center font-small text-primary hover:bg-opacity-90 `}
              >
                {disabled ? "loading" : "ok"}
              </button>
              <button
                onClick={clearFiles}
                className="ms-4 inline-flex items-center justify-center rounded-md border border-red-500 py-1 px-3 text-center font-medium text-red-500 hover:bg-opacity-90 "
              >
                X
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ImageUploader;
